import type { TargetingProductLine } from "./types";

const ERP_NAMES: Record<number, string> = { 1: "Decade", 2: "Oracle", 3: "Unidata" };
export function buildMessageBrandOptions(lines: TargetingProductLine[]) {
	const brands = new Map<string, { id: string; name: string; productLines: { id: string; name: string }[] }>();
	const nameCounts = new Map<string, number>();
	for (const line of lines) {
		const key = line.brandCode + "|" + line.productLineName;
		nameCounts.set(key, (nameCounts.get(key) ?? 0) + 1);
	}
	for (const line of lines) {
		const brand = brands.get(line.brandCode) ?? { id: line.brandCode, name: line.brandName, productLines: [] };
		const duplicateName = (nameCounts.get(line.brandCode + "|" + line.productLineName) ?? 0) > 1;
		brand.productLines.push({
			id: line.productLineKey,
			name: line.productLineName + (duplicateName ? " (" + (ERP_NAMES[line.originId] ?? line.originId) + ")" : "")
		});
		brands.set(line.brandCode, brand);
	}
	return [...brands.values()]
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((brand) => ({
			...brand,
			productLines: brand.productLines.sort((a, b) => a.name.localeCompare(b.name))
		}));
}
